module.exports = __webpack_public_path__ + "static/img/btn_tery_sms_receive.e6601b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_tery_sms_receive.png
// module id = o8ZN
// module chunks = 1